import React, { Component } from 'react'
import Twitter from '../SocialMediaIcons/Twitter'
import Facebook from '../SocialMediaIcons/Facebook'

import './styles.scss'

class SocialShare extends Component {
  twitterShare = e => {
    e.preventDefault()
    const twitterWindow = window.open(
      `https://twitter.com/share?url=${document.URL}`,
      'twitter-popup',
      'height=350,width=600'
    )
    if (twitterWindow.focus) {
      twitterWindow.focus()
    }
    return false
  }

  facebookShare = e => {
    e.preventDefault()
    const facebookWindow = window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${document.URL}`,
      'facebook-popup',
      'height=350,width=600'
    )
    if (facebookWindow.focus) {
      facebookWindow.focus()
    }
    return false
  }

  render() {
    return (
      <div className="social-share">
        <button
          type="button"
          onClick={this.twitterShare}
          className="social-share__button twitter twitter-share-button"
          data-js="twitter-share"
          data-size="large"
          title="Share on Twitter"
        >
          <Twitter iconSize="big" />
          <span className="social-share__button__tooltip">
            Share on Twitter
          </span>
        </button>
        <button
          type="button"
          onClick={this.facebookShare}
          className="social-share__button facebook"
          data-js="facebook-share"
          title="Share on Facebook"
        >
          <Facebook iconSize="big" />
          <span className="social-share__button__tooltip">
            Share on Facebook
          </span>
        </button>
      </div>
    )
  }
}

export default SocialShare
